export default class Tareas {
    constructor($scope,
                method,
                $routeParams,
                tareasService,
                herramientasService,
                $filter,
                $q,
                riesgoService,
                $location,
                $uibModal,
                toastr) {
        this.scope = $scope;
        this.q = $q;
        this.location = $location;
        this.toastr = toastr;
        this.modal = $uibModal;
        switch (method) {
            case 'list':
                this.list(tareasService);
                break;
            case 'view':
                this.view($routeParams, tareasService, herramientasService, riesgoService, $filter);
                break;
            case 'new':
                this.create(tareasService, herramientasService, riesgoService, $filter);
                break;
        }
    }

    list(tareasService) {

        let self = this.scope;

        tareasService.getAll()
            .then((resp) => {
                self.tareas = resp.data.message;
            });

        self.getItemPage = (item) => {
            let index = self.tareas.indexOf(item);
            let pageNumber = Math.floor(index / 10) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, tareasService);
        /*
        this.scope.inAction = false;
        this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                tareasService.delete({_id: id}).then((resp) => {
                    this.toastr.success('Tarea eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    window.location.reload();
                })
                    .catch((err) => {
                        this.scope.inAction = false;
                        this.toastr.error('Error', 'Error al eliminar la tarea!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }
        };*/
    }

    view($routeParams, tareasService, herramientasService, riesgoService, $filter) {
        this.scope.aux = {};
        let id = $routeParams.id;
        var self = this.scope;

        this.scope.lista = {
            izquierda: [],
            derecha: [],
            addVal: [],
            removeVal: [],
        };

        this.scope.full = {
            izquierda: [],
            derecha: []
        };

        this.scope.lista.options = {
            leftContainerLabel: 'Herramientas disponibles',
            rightContainerLabel: 'Herramientas Seleccionadas',
            active: true,
            leftContainerSearch: function (text) {
                let objetive = self.lista.izquierda;
                objetive = $filter('filter')(self.full.izquierda, {
                    'name': text
                });

            },
            rightContainerSearch: function (text) {
                let objetive = self.lista.derecha;
                objetive = $filter('filter')(self.full.derecha, {
                    'name': text
                });
            },
        };

        this.diference = (iz, der) => {
            for (var el in der) {
                let aux = der[el];
                let index = _.findIndex(iz, (e) => {
                    return e._id == aux._id
                });
                if (index >= 0) {
                    iz.splice(index, 1);
                }
            }
            return iz;
        };

        riesgoService.getAll()
            .then((resp) => {
                this.scope.riesgos = resp.data.message;
            });

        this.q.all([
            herramientasService.getAll()
                .then((resp) => {
                    let herramientas = resp.data.message;
                    this.scope.lista.izquierda = herramientas;
                    // this.scope.full.izquierda  = angular.copy(herramientas);
                }),
            tareasService.getAll({_id: id})
                .then((resp) => {
                    this.scope.tarea = resp.data.message[0];
                    let time = new Date(this.scope.tarea.horas_estimadas);
                    this.scope.tarea.horas_estimadas =  new Date(Date.UTC(time.getUTCFullYear(), time.getUTCMonth(), time.getUTCDate(),
                    time.getUTCHours(), time.getUTCMinutes(), time.getUTCSeconds()));
                    let herramientas = resp.data.message[0].herramientas;
                    this.scope.lista.derecha = herramientas;
                })])
            .then(() => {
                let filtrado = this.diference(this.scope.lista.izquierda, this.scope.lista.derecha);
                this.scope.lista.izquierda = filtrado;
            });

        this.scope.inAction = false;
        this.scope.save = () => {
            if (!this.scope.inAction && this.scope.lista.derecha.length > 0) {
                this.scope.inAction = true;
                let tarea = this.scope.tarea;
                tarea.herramientas = this.scope.lista.derecha;
                tareasService.update(tarea)
                    .then((resp) => {
                        this.toastr.success('Tarea modificada correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        this.location.path('/tareas');
                    }).catch((er) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar la tarea!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };
    }

    create(tareasService, herramientasService, riesgoService, $filter) {
        this.scope.tarea = {};
        this.scope.aux = {};
        var self = this.scope;
        self.tarea = {
            esRequerida : false
        }

        this.scope.lista = {
            izquierda: [],
            derecha: [],
            addVal: [],
            removeVal: []
        };

        this.scope.full = {
            izquierda: [],
            derecha: []
        };

        this.scope.lista.options = {
            leftContainerLabel: 'Herramientas disponibles',
            rightContainerLabel: 'Herramientas Seleccionadas',
            active: true,
            leftContainerSearch: function (text) {
                self.lista.izquierda = $filter('filter')(self.full.izquierda, {
                    'nombre': text
                });

            },
            rightContainerSearch: function (text) {
                self.lista.derecha = $filter('filter')(self.full.derecha, {
                    'nombre': text
                });
            },
        };

        herramientasService.getAll()
            .then((resp) => {
                let aux = resp.data.message;
                this.scope.full.izquierda = aux;
                this.scope.lista.izquierda = angular.copy(aux);
            });

        riesgoService.getAll()
            .then((resp) => {
                this.scope.riesgos = resp.data.message;
            });

        this.scope.inAction = false;
        this.scope.save = () => {
            if (!this.scope.inAction && this.scope.lista.derecha.length > 0) {
                this.scope.inAction = true;
                let tarea = this.scope.tarea;
                var timezone = tarea.horas_estimadas.getTimezoneOffset();
		        tarea.horas_estimadas.setTime(tarea.horas_estimadas.getTime());
                tarea.herramientas = this.scope.lista.derecha;
                tareasService.save(tarea)
                    .then((resp) => {
                        this.toastr.success('Tarea creada correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        this.location.path('/tareas');
                    }).catch((er) => {
                        this.scope.inAction = false;
                        this.toastr.error('Error', 'Error al crear la tarea!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }
        };
    }

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Tarea</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar la tarea: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 10 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.tareas.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Tarea eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar la tarea!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}



// WEBPACK FOOTER //
// ./app/js/controllers/tareas/tareas.js